import qs from 'qs';
import { network } from 'services/network';

import { QueryParams } from 'api/queries/getRiskRegister.query';

const ENDPOINT = 'api/bo/getRiskRegister';

export const getRiskRegister = (params: QueryParams, endpoint = ENDPOINT) => {
    const querystring = qs.stringify(params, { addQueryPrefix: true, skipNulls: true });

    const url = `${endpoint}${querystring}`;

    return network.get(url).then((response) => {
        return response.data;
    });
};
